import React, { ChangeEvent, FC, useRef, useState } from 'react';
import Textbox from '~/src/components/form-components/textbox/textbox';
import { validateEmail } from '~/src/helpers/inputs-validators';
import { removingSpaces } from '~/src/helpers/removing-spaces';
import { EMAIL_ERROR } from '~/src/components/common-components/email-field/email-field.constants';
import type { TextBoxFieldProps } from '~/src/models/types/fields.types';

export const EmailField: FC<TextBoxFieldProps> = (props) => {
    const [emailError, setEmailError] = useState('');
    const [emailValue, setEmailValue] = useState('');
    const [isValidatedEmail, setIsValidatedEmail] = useState(false);

    const emailInputRef = useRef<HTMLInputElement>(null);

    const onEmailErrorHandler = (value: string) => {
        const isValidEmail = validateEmail(value);
        !isValidEmail && setEmailError(EMAIL_ERROR);
        (isValidEmail || !value) && setEmailError('');
        setIsValidatedEmail(isValidEmail);
    };

    const onEmailValueChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        const _value = event.target.value || '';
        const emailWithoutSpaces = removingSpaces(_value);
        const input = event.target;

        const cursorPosition = input.selectionStart ?? _value.length;
        const nextCursorPosition = removingSpaces(_value.slice(0, cursorPosition)).length;

        requestAnimationFrame(() => {
            emailInputRef.current?.setSelectionRange(nextCursorPosition, nextCursorPosition);
        });

        setEmailValue(emailWithoutSpaces);
        onEmailErrorHandler(emailWithoutSpaces);
    };

    return (
        <Textbox
            value={emailValue}
            onValueChange={onEmailValueChangeHandler}
            onClear={() => setEmailValue('')}
            error={emailError}
            validated={isValidatedEmail}
            externalInputRef={emailInputRef}
            {...props}
        />
    );
};